











































































import { computed, defineComponent, ref, watch } from '@nuxtjs/composition-api'
import Container from '@/packages/basis/components/Container.vue'

export default defineComponent({
  name: 'SectionDropdown',
  components: { Container },
  props: {
    topTitle: {
      type: String,
      default: '',
    },
    preMainTitle: {
      type: String,
      default: '',
    },
    mainTitle: {
      type: String,
      default: '',
    },
    imgTitle: {
      type: Array,
      default: () => [],
    },
    dropTitleFirst: {
      type: String,
      default: '',
    },
    dropDescriptionFirst: {
      type: String,
      default: '',
    },
    dropDescriptionSecond: {
      type: String,
      default: '',
    },
    cardTitle: {
      type: String,
      default: '',
    },
    cardPrice: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '',
    },
    btnLink: {
      type: String,
      default: '',
    },
    imgMain: {
      type: Array,
      default: () => [],
    },
    dropTitleSecond: {
      type: String,
      default: '',
    },
    openDrop: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    // создаём реактивный массив
    const openDrops = ref<boolean[]>([false, false])

    // если вы всё-таки хотите инициализировать его из props.openDrop:
    watch(
      () => props.openDrop,
      (val) => {
        if (val === '1') openDrops.value = [true, false]
        else if (val === '2') openDrops.value = [false, true]
        else openDrops.value = [false, false]
      },
      { immediate: true }
    )

    const dropBlocks = computed(() => [
      { title: props.dropTitleFirst, description: props.dropDescriptionFirst },
      {
        title: props.dropTitleSecond,
        description: props.dropDescriptionSecond,
      },
    ])

    function toggleDrop(idx: number) {
      // если кликаем по уже открытому — закрыть всё
      if (openDrops.value[idx]) {
        openDrops.value = [false, false]
      } else {
        // иначе открываем только этот
        openDrops.value = openDrops.value.map((_, i) => i === idx)
      }
    }

    return { openDrops, dropBlocks, toggleDrop }
  },
})
